import { NotificationStatus } from './../../models/notification';

export interface ISystemState {
    loading: boolean;
    status: NotificationStatus;
}

export const initialSystemState: ISystemState = {
    loading: false,
    status: null
};
